import styled from '@emotion/styled';

export const BlockMenuWrapper = styled.div`
  position: relative;
  display: flex;

  [data-block-button] {
    visibility: hidden;
  }

  &:hover [data-block-button] {
    visibility: visible;
  }
`;

export const BlockContent = styled.div`
  width: 100%;
`;
